export default class SendBuffer {
  constructor({ flushSize }) {
    this.flushSize = flushSize;
    this.packetBuffer = [];
    this.packetBufferSize = 0;
    this.onFlush = (buffer) => {};
  }
  changeFlushSize(flushSize) {
    this.flush();
    this.flushSize = flushSize;
  }
  append(packet) {
    const preparedPacket = this._preparePacketForSending(packet);
    if (
      this.packetBufferSize + preparedPacket.originalLength >
      this.flushSize
    ) {
      this.flush();
    }
    this.packetBuffer.push(preparedPacket);
    this.packetBufferSize += preparedPacket.originalLength;
  }
  flush() {
    const flushBuffer = concatArrayBuffers(
      this.packetBuffer.map((packet) => packet.data)
    );
    this.onFlush(flushBuffer);
    this.packetBuffer = [];
    this.packetBufferSize = 0;
  }
  _preparePacketForSending(packet) {
    const originalLength = packet.data.byteLength;
    const finalLength = originalLength + 4;

    const lengthBuffer = Buffer.alloc(4);
    lengthBuffer.writeInt32BE(originalLength);

    const dataBuffer = Buffer.from(packet.data);

    const buffer = Buffer.concat([lengthBuffer, dataBuffer], finalLength);

    return {
      data: buffer,
      originalLength: packet.data.byteLength,
      finalLength: finalLength
    };
  }
}

var concatArrayBuffers = function (buffers) {
  let finalSize = buffers.reduce(
    (size, buffer) => (size += buffer.byteLength),
    0
  );
  var offset = 0;
  var tmp = new Uint8Array(finalSize);

  for (const buffer of buffers) {
    const bufferData = new Uint8Array(buffer);
    tmp.set(bufferData, offset);
    offset += bufferData.length;
  }

  return Buffer.from(tmp.buffer);
};
